(function () {
  const modal = document.querySelector('[data-pp-offer]');
  const hint = document.querySelector('[data-offer-invitation]');
  if (!modal || !hint || !modal.showModal || window.Shopify?.designMode) return;

  const seenKey = 'pp-offer-seen-v1';
  const intentKey = 'pp-purchase-intent';
  const sharedIntentKey = 'pp-purchase-intent-at-v1';
  const week = 7 * 86400000;
  const cartLifetime = 15000;
  const mouseDevice = matchMedia('(hover: hover) and (pointer: fine)');
  const openButton = hint.querySelector('[data-offer-open]');
  const purchase = [
    '[data-add-to-cart]', '[data-mobile-add]', '[data-cart-checkout]',
    '[data-pack-button]', '[data-variant-button]', '[data-size-chip]',
    '[data-bundle-size-chip]', '[data-size-select]', '[data-bundle-size-select]',
    '[data-customize-sizes]', '[data-pack-quiz-apply]', '[data-quantity]',
    '[data-gift-cover-choice]', '[data-gift-cover-select]', '[data-gift-cover-age-select]',
    '[data-direct-upsell-choice]', '[data-direct-upsell-add]', '[data-direct-upsell-skip]',
    '[data-offer-apply]', '.shopify-payment-button',
    'a[href*="/checkout"]', 'a[href*="/cart"]', '[name="checkout"]'
  ].join(',');
  const information = [
    '[data-labs-note-trigger]', '[data-pp-tab]', '[data-pp-detail]', '[data-pp-zone]',
    '[data-pack-quiz-open]', '[data-size-guide-open]', '[data-before-after-range]',
    '.faq-item summary', '.faq-section summary'
  ].join(',');
  const interactions = new Set();
  let state = 'watching', suspended = false, claimedAt = 0, previousFocus;
  let visibleMs = 0, lastTick = Date.now(), lastActivity = Date.now();
  let maxScroll = window.scrollY, mode = mouseDevice.matches ? 'mouse' : 'touch';
  let usedPointer = false, awaySince = null, awayEngaged = false;
  let returnUntil = 0, returnAfter = 0, timer;
  let cartEmpty = false, cartCheckedAt = 0, nextCartCheck = 0, cartFailures = 0;
  let cartRequest = null, expiryTimer;

  function frequencyBlocked() {
    try {
      const seen = Number(localStorage.getItem(seenKey) || 0);
      return Boolean(sessionStorage.getItem(intentKey)) ||
        Date.now() - Number(localStorage.getItem(sharedIntentKey) || 0) < 30 * 60000 ||
        (seen !== claimedAt && Date.now() - seen < week);
    } catch (_) { return true; }
  }
  if (frequencyBlocked()) return;

  function hideInvitation() {
    hint.hidden = true;
    if (state === 'invitation') state = 'watching';
  }
  function invalidateCart() {
    cartEmpty = false;
    cartCheckedAt = 0;
    clearTimeout(expiryTimer);
    const request = cartRequest;
    cartRequest = null;
    request?.controller.abort();
    hideInvitation();
  }
  function stop() {
    state = 'done';
    clearInterval(timer);
    timer = null;
    invalidateCart();
    if (modal.open) modal.close();
  }
  function blockPurchase() {
    previousFocus = null;
    try {
      sessionStorage.setItem(intentKey, '1');
      localStorage.setItem(sharedIntentKey, String(Date.now()));
    } catch (_) {}
    stop();
  }
  function foreground() {
    return !suspended && !document.hidden && document.hasFocus();
  }
  function freshEmptyCart() {
    return cartEmpty && Date.now() - cartCheckedAt < cartLifetime;
  }
  function visible(element) {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight &&
      style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  }
  function busy() {
    if (document.querySelector('[data-direct-checkout-upsell]:not([hidden])')) {
      blockPurchase();
      return true;
    }
    return [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')]
      .some(element => element !== modal && visible(element)) ||
      document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
  }
  function shoppingInView() {
    return [...document.querySelectorAll('[data-bundle-anchor],.purchase-form,[data-pack-button],[data-size-select]')]
      .some(visible);
  }
  function engaged() {
    const scrollable = document.documentElement.scrollHeight - innerHeight;
    const readingDistance = Math.min(scrollable * 0.4, innerHeight * 2);
    return interactions.size >= 2 || (readingDistance > 0 && maxScroll >= readingDistance);
  }
  function available() {
    if (state === 'done' || state === 'open' || !foreground()) return false;
    if (frequencyBlocked()) { stop(); return false; }
    return !busy();
  }
  function recordSeen() {
    if (frequencyBlocked()) return false;
    try {
      claimedAt = Date.now();
      localStorage.setItem(seenKey, String(claimedAt));
      return true;
    } catch (_) { return false; }
  }

  async function checkCart() {
    if (cartRequest || !available() || Date.now() < nextCartCheck) return;
    const request = { controller: new AbortController() };
    cartRequest = request;
    const timeout = setTimeout(() => request.controller.abort(), 10000);
    try {
      const response = await fetch(modal.dataset.cartUrl, {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: request.controller.signal
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (cartRequest !== request || state === 'done') return;
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart');
      if (cart.item_count > 0) { blockPurchase(); return; }
      if (!foreground() || frequencyBlocked()) return;
      cartEmpty = true;
      cartCheckedAt = Date.now();
      cartFailures = 0;
      nextCartCheck = cartCheckedAt + 10000;
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(() => {
        if (!freshEmptyCart()) hideInvitation();
      }, cartLifetime);
    } catch (_) {
      if (cartRequest !== request || state === 'done') return;
      cartEmpty = false;
      cartCheckedAt = 0;
      hideInvitation();
      cartFailures += 1;
      nextCartCheck = Date.now() + Math.min(30000, 5000 * Math.pow(2, cartFailures - 1));
    } finally {
      clearTimeout(timeout);
      if (cartRequest === request) cartRequest = null;
    }
  }
  function openOffer(fromInvitation) {
    if (!available()) return;
    if (fromInvitation && (state !== 'invitation' || shoppingInView())) return;
    if (!freshEmptyCart()) {
      hideInvitation();
      checkCart();
      return;
    }
    if (!fromInvitation) previousFocus = document.activeElement;
    try {
      modal.showModal();
      if (!recordSeen()) { stop(); return; }
      state = 'open';
      clearInterval(timer);
      timer = null;
      invalidateCart();
    } catch (_) { hideInvitation(); }
  }
  function placeInvitation() {
    const bar = document.querySelector('[data-mobile-sticky]');
    const offset = bar && visible(bar) ? Math.max(0, innerHeight - bar.getBoundingClientRect().top) : 0;
    hint.style.setProperty('--pp-offer-bar-height', `${Math.ceil(offset)}px`);
  }
  function showInvitation() {
    if (!available() || mode !== 'touch' || !freshEmptyCart() || shoppingInView()) return;
    if (state !== 'invitation') {
      previousFocus = document.activeElement;
      state = 'invitation';
      placeInvitation();
      hint.hidden = false;
    }
    returnUntil = 0;
  }
  function setMode(nextMode) {
    if (mode === nextMode) return;
    mode = nextMode;
    if (mode === 'mouse') hideInvitation();
  }
  function activity() {
    lastActivity = Date.now();
    returnUntil = 0;
  }
  function pointerActivity(event) {
    if (!event.isTrusted) return;
    if (event.pointerType === 'touch' || event.pointerType === 'pen') {
      usedPointer = true;
      setMode('touch');
    } else if (event.pointerType === 'mouse') {
      usedPointer = true;
      setMode('mouse');
    }
    activity();
  }
  ['pointerdown', 'pointermove'].forEach(name => document.addEventListener(name, pointerActivity, { passive: true }));
  document.addEventListener('touchstart', event => {
    if (!event.isTrusted) return;
    usedPointer = true;
    setMode('touch');
    activity();
  }, { passive: true });
  ['keydown', 'scroll'].forEach(name => document.addEventListener(name, activity, { passive: true }));
  document.addEventListener('scroll', () => {
    maxScroll = Math.max(maxScroll, window.scrollY);
  }, { passive: true });
  mouseDevice.addEventListener('change', () => {
    if (!usedPointer) setMode(mouseDevice.matches ? 'mouse' : 'touch');
  });

  function userAction(event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (event.target.closest(purchase)) { blockPurchase(); return; }
    const target = event.target.closest(information);
    if (target) interactions.add(target);
  }
  ['click', 'input', 'change'].forEach(name => document.addEventListener(name, userAction, true));
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-ajax-product-form],form[action*="/cart"]')) blockPurchase();
  }, true);
  document.addEventListener('mouseout', event => {
    if (event.relatedTarget || event.clientY > 12 || mode !== 'mouse' || visibleMs < 45000 || !engaged()) return;
    openOffer(false);
  });

  function tick() {
    const now = Date.now(), delta = Math.max(0, Math.min(5000, now - lastTick));
    lastTick = now;
    if (state === 'done' || state === 'open' || suspended) return;
    if (frequencyBlocked()) { stop(); return; }
    if (!document.hidden) visibleMs += delta;
    if (!foreground()) return;
    if (awaySince !== null) resume();
    if (busy()) { hideInvitation(); return; }
    if (visibleMs >= 30000 && engaged()) checkCart();
    if (state === 'invitation') {
      if (mode !== 'touch' || !freshEmptyCart() || shoppingInView()) hideInvitation();
      else placeInvitation();
      return;
    }
    if (mode !== 'touch' || visibleMs < 60000 || !engaged()) return;
    const returned = now >= returnAfter && now < returnUntil;
    if (returned || now - lastActivity >= 20000) showInvitation();
  }
  function startTimer() {
    if (!timer && state !== 'done' && state !== 'open') timer = setInterval(tick, 1000);
  }
  function leave() {
    if (state === 'done') return;
    if (awaySince === null) {
      awaySince = Date.now();
      awayEngaged = engaged();
    }
    returnUntil = 0;
    lastTick = Date.now();
    invalidateCart();
  }
  function resume() {
    if (!foreground() || state === 'done') return;
    const now = Date.now();
    if (awaySince === null) return;
    const absentMs = now - awaySince;
    awaySince = null;
    lastTick = lastActivity = now;
    if (frequencyBlocked()) { stop(); return; }
    if (state === 'open') return;
    if (mode === 'touch' && awayEngaged && absentMs >= 8000) {
      returnAfter = now + 2000;
      returnUntil = now + 30000;
    }
    nextCartCheck = 0;
    cartFailures = 0;
    checkCart();
    startTimer();
  }

  openButton.addEventListener('click', () => openOffer(true));
  hint.querySelector('[data-offer-dismiss]').addEventListener('click', () => {
    if (hint.hidden) return;
    recordSeen();
    stop();
  });
  modal.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => modal.close()));
  modal.addEventListener('close', () => {
    stop();
    if (previousFocus?.isConnected && previousFocus.getClientRects().length) previousFocus.focus({ preventScroll: true });
  });
  window.addEventListener('storage', event => {
    if ([seenKey, sharedIntentKey, null].includes(event.key) && frequencyBlocked()) stop();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) leave();
    else resume();
  });
  window.addEventListener('blur', leave);
  window.addEventListener('focus', resume);
  window.addEventListener('pagehide', () => {
    leave();
    suspended = true;
    clearInterval(timer);
    timer = null;
    if (modal.open) modal.close();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted || state === 'done') return;
    suspended = false;
    maxScroll = Math.max(maxScroll, window.scrollY);
    resume();
    startTimer();
  });
  window.addEventListener('online', () => {
    if (state === 'done' || state === 'open' || !foreground()) return;
    nextCartCheck = 0;
    checkCart();
  });
  startTimer();
})();
